<template>
  <div class="container">
    <div class="content">
      <img src="@/assets/tg/tg6_title.png" class="title" />
      <div class="query-box">
        <div class="form-item">
          <select v-model="education" :style="{ color: education.length ? '#000' : '#6A6A6A' }">
            <option value="" disable>请选择您目前学历</option>
            <option value="大专">大专</option>
            <option value="本科">本科</option>
          </select>
          <div class="arrow"></div>
        </div>
        <div class="form-item">
          <select v-model="major" :style="{ color: major.length ? '#000' : '#6A6A6A' }">
            <option value="" disable>请选择您报考的专业</option>
            <option value="管理学">管理学</option>
            <option value="医学">医学</option>
            <option value="法学">法学</option>
            <option value="经济学">经济学</option>
            <option value="金融学">金融学</option>
            <option value="心理学">心理学</option>
            <option value="教育学">教育学</option>
            <option value="计算机类">计算机类</option>
            <option value="理学">理学</option>
            <option value="工学">工学</option>
            <option value="会计学">会计学</option>
            <option value="其他">其他</option>
          </select>
          <div class="arrow"></div>
        </div>
        <div class="form-item">
          <input type="text" placeholder="请输入您的手机号" v-model="mobile" maxlength="11" />
        </div>
        <button @click="queryClick">立即查询</button>
      </div>
    </div>
    <div class="bottom-container">
      <div class="hint-box">
        <h3>友情提示</h3>
        <ul>
          <li>1、本网站为在职研究生报名考试信息查询服务（含报考条件、各省报名时间、报名网址、资格审核等）;</li>
          <li>2、在职研究生统一网上报名时间为：2024年10月份（各省份在此时间段内自行安排时间）；</li>
          <li>3、考生需认真阅读相关文件，了解相关规定及注意事项等内容，根据本人实际情况进行报名，并按照提示填写报考信息；</li>
          <li>4、本网站所有信息会根据当年度变化而变动，请考生实时关注。</li>
        </ul>
      </div>
      <div class="copy-right">{{ $route.path == '/tg6' ? '郑州中课网络科技有限公司' : '河南要学信息科技有限公司' }}</div>
    </div>

    <el-dialog
      class="submit-dialog"
      style="border-radius: 10px"
      :visible.sync="dialogVisible"
      :show-close="false"
      center
      width="480px"
      append-to-body
    >
      <div class="submitMian">已提交，该信息查询平台已为您转接人工服务，<br />服务时间：9点-18点。请注意接听。</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">我知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import md5 from 'js-md5'
import { phoneValidator, isMobile } from '@/utils/index'
import { graduatePromot } from '@/api/index.js'
export default {
  data() {
    return {
      education: '',
      major: '',
      mobile: '',

      isLoading: false,
      dialogVisible: false
    }
  },

  methods: {
    queryClick() {
      if (!this.education.length) {
        return this.$message.error('请选择您目前学历')
      }
      if (!this.major.length) {
        return this.$message.error('请选择您报考的专业')
      }

      if (!this.mobile.length) {
        return this.$message.error('请输入您的手机号')
      }

      if (!phoneValidator(this.mobile)) {
        return this.$message.error('手机号格式错误')
      }

      if (this.isLoading) {
        return
      }
      this.isLoading = true
      const gt = new Date().getTime().toString()
      graduatePromot({
        time: gt,
        encryPwd: md5(gt + 'verify'),
        mobile: this.mobile,
        originurl: window.location.origin + window.location.pathname,
        collegeName: '考研网课',
        orign: '百度信息流',
        promotedAccount: this.$route.path == '/tg6' ? '中课网校12-sl' : 'wy要学-考研-sl',
        remark: `【学历：${this.education}】【专业：${this.major}】`
      })
        .then(res => {})
        .finally(() => {
          window._agl && window._agl.push(['track', ['success', { t: 3 }]])

          this.education = ''
          this.mobile = ''
          this.dialogVisible = true
          this.isLoading = false
        })
    }
  },
  mounted() {
    window._agl = window._agl || []
    window._agl.push(['production', '_f7L2XwGXjyszb4d1e2oxPybgD'])
    const agl = document.createElement('script')
    agl.type = 'text/javascript'
    agl.async = true
    agl.src = 'https://fxgate.baidu.com/angelia/fcagl.js?production=_f7L2XwGXjyszb4d1e2oxPybgD'
    const s = document.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(agl, s)
  },
  metaInfo() {
    return {
      title: `中国研究生招考信息网`
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100vh;
  background: url(../../assets/tg/tg6_bg.jpg) no-repeat;
  background-size: 100% 100%;
  overflow: scroll;
  background-repeat: no-repeat;
  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-bottom: 40px;
    margin-top: 100px;
    .title {
      width: 76%;
    }
    .query-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 50px;
      width: 825px;
      height: 425px;
      padding-top: 95px;
      background: url(../../assets/tg/tg6_form_bg.png) no-repeat;
      h2 {
        display: flex;
        align-items: center;
        padding-top: 30px;
        padding-bottom: 20px;
        font-size: 35px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #000;
        img {
          width: 56px;
          height: 56px;
          margin-right: 15px;
        }
      }
      .line {
        height: 1px;
        width: 625px;
        background-color: rgb(201, 200, 201);
      }
      .form-item {
        position: relative;
        display: flex;
        align-items: center;
        margin-top: 20px;
        select,
        input {
          width: 625px;
          height: 70px;
          padding-left: 20px;
          background: #ffffff;
          font-size: 18px;
          border: 1px solid rgb(222, 222, 222);
          box-sizing: border-box;
          outline: none;
        }
        select {
          appearance: none;
          -moz-appearance: none;
          -webkit-appearance: none;
        }
        .arrow {
          position: absolute;
          top: 0;
          right: 0;
          width: 12px;
          height: 12px;
          margin-right: 16px;
          margin-top: 26px;
          transform: rotate(45deg);
          border-bottom: 2px solid #000;
          border-right: 2px solid #000;
        }
      }
      button {
        width: 360px;
        height: 64px;
        margin-top: 35px;
        font-size: 22px;
        color: #ffffff;
        font-weight: bold;
        background: linear-gradient(90deg, rgb(254, 100, 101), rgb(219, 20, 21));
        border-radius: 10px;
        outline: none;
        border: none;
        cursor: pointer;
      }
    }
  }
  .bottom-container {
    width: 100%;
    height: 313px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .hint-box {
      h3 {
        font-size: 26px;
        font-weight: bold;
        font-family: Microsoft YaHei;
        // text-shadow: 2px 2px 0 #fff;
        color: #de0000;
      }
      ul {
        list-style: none;
        margin-top: 10px;
        li {
          margin-top: 8px;
          font-size: 19px;
          font-family: Microsoft YaHei;
          color: #000;
          //   text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
        }
      }
    }
    .copy-right {
      margin-top: 40px;
      text-align: center;
      color: #000;
      font-size: 19px;
      //   text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    }
  }
}

.submit-dialog {
  ::v-deep .el-dialog__wrapper {
    border-radius: 10px !important;
  }
  .submitMian {
    font-size: 20px;
    color: #000;
  }
  .el-button {
    width: 240px;
    height: 60px;
    border: none;
    font-size: 22px;
    border-radius: 10px;
    background: linear-gradient(90deg, rgb(254, 100, 101), rgb(219, 20, 21));
  }
  ::v-deep .el-dialog {
    border-radius: 10px;
  }
}

@media (max-width: 992px) {
  .container {
    .content {
      .title {
        width: 50%;
      }
      .query-box {
        zoom: 90%;
      }
    }
  }
}

@media (min-width: 993px) and (max-width: 1280px) {
  .container {
    .content {
      .title {
        width: 50%;
      }
      .query-box {
        zoom: 70%;
      }
    }
    .bottom-container {
      zoom: 80%;
    }
  }
}

@media (min-width: 1921px) {
  .container {
    .content {
      zoom: 95%;
    }
  }
}
</style>
<style>
body {
  min-width: 100%;
}
</style>
